import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  id: "form-section-editor",
  class: "modal-mask"
}
const _hoisted_3 = { class: "modal-wrapper" }
const _hoisted_4 = { class: "modal-dialog" }
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = { class: "modal-header" }
const _hoisted_7 = { class: "modal-title" }
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "text-danger" }
const _hoisted_11 = { class: "modal-footer" }
const _hoisted_12 = {
  type: "submit",
  form: "form-designer-form-section-editor-form",
  class: "btn btn-primary"
}
const _hoisted_13 = {
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-lg-6" }
const _hoisted_16 = { class: "col-lg-6 text-right" }
const _hoisted_17 = { class: "container-fluid p-0" }
const _hoisted_18 = { class: "row no-gutters" }
const _hoisted_19 = {
  class: "col-lg-4 col-md-5 col-sm-6",
  style: {"max-height":"calc(100vh - 250px)","height":"calc(100vh - 250px)","overflow-y":"auto"}
}
const _hoisted_20 = {
  key: 0,
  style: {"padding-left":"15px"}
}
const _hoisted_21 = { id: "FormFieldsManagerPlaceholder" }
const _hoisted_22 = { class: "input-group" }
const _hoisted_23 = { class: "mt-3" }
const _hoisted_24 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_25 = { class: "font-weight-light" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 1,
  class: "font-italic"
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "row no-gutters" }
const _hoisted_31 = {
  key: 0,
  class: "border rounded px-2 py-3 bg-light"
}
const _hoisted_32 = { class: "mb-0 text-ellipsis font-weight-light text-muted" }
const _hoisted_33 = ["title"]
const _hoisted_34 = ["title", "onDragstart", "onDragend"]
const _hoisted_35 = { class: "mb-0 text-ellipsis font-weight-light" }
const _hoisted_36 = { class: "name" }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = {
  class: "py-4",
  style: {"padding":"15px"}
}
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = ["value"]
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = { class: "form-group" }
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = { class: "form-check" }
const _hoisted_45 = { class: "form-group" }
const _hoisted_46 = { class: "form-check" }
const _hoisted_47 = {
  class: "col-lg-8 col-md-7 col-sm-6 bg-light",
  style: {"padding":"20px 20px 20px 5px","max-height":"calc(100vh - 250px)","height":"calc(100vh - 250px)","overflow-y":"auto"}
}
const _hoisted_48 = { style: {"padding-left":"30px"} }
const _hoisted_49 = { class: "form-group mt-3 px-2 py-1" }
const _hoisted_50 = { class: "error" }
const _hoisted_51 = { class: "mt-3 px-2 py-1" }
const _hoisted_52 = { class: "mb-1" }
const _hoisted_53 = { class: "mt-3 px-2 py-1" }
const _hoisted_54 = { class: "mb-1" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { class: "clearfix" }
const _hoisted_57 = {
  class: "switch float-left",
  style: {"margin-top":"4px"}
}
const _hoisted_58 = { class: "mt-3 px-2 py-1" }
const _hoisted_59 = { class: "mb-1" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { class: "clearfix" }
const _hoisted_62 = {
  class: "switch float-left",
  style: {"margin-top":"4px"}
}
const _hoisted_63 = {
  key: 0,
  style: {"margin-left":"25px"}
}
const _hoisted_64 = ["onClick"]
const _hoisted_65 = ["onDragenter", "onDragleave", "onDrop"]
const _hoisted_66 = {
  key: 1,
  class: "alert alert-warning mb-4 mx-4",
  role: "alert"
}
const _hoisted_67 = ["onClick"]
const _hoisted_68 = ["title", "onDragstart", "onDragend"]
const _hoisted_69 = { class: "name d-none" }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = ["onClick"]
const _hoisted_72 = { class: "mb-1" }
const _hoisted_73 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_74 = { class: "name" }
const _hoisted_75 = { class: "text-muted" }
const _hoisted_76 = ["onDragenter", "onDragleave", "onDrop"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormEditor = _resolveComponent("FormEditor")!
  const _component_AlternativeEditorDialog = _resolveComponent("AlternativeEditorDialog")!
  const _component_AttributeEditorDialog = _resolveComponent("AttributeEditorDialog")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_FormEditor, {
      viewModel: _ctx.formEditor,
      onSaveForm: _ctx.handleRenameFormCommand
    }, null, 8 /* PROPS */, ["viewModel", "onSaveForm"]),
    _createVNode(_component_AlternativeEditorDialog, { viewModel: _ctx.alternativeEditorDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_AttributeEditorDialog, {
      viewModel: _ctx.attributeEditorDialog,
      onAttributeCreated: _ctx.handleLoadAttribute
    }, null, 8 /* PROPS */, ["viewModel", "onAttributeCreated"]),
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    (_ctx.rm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.formSectionEditor.opened)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.formSectionEditor.title), 1 /* TEXT */),
                        _createElementVNode("button", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.formSectionEditor.close())),
                          type: "button",
                          class: "close"
                        }, "×")
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("form", {
                          id: "form-designer-form-section-editor-form",
                          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFormSectionEditorSubmit && _ctx.handleFormSectionEditorSubmit(...args)), ["prevent"]))
                        }, [
                          _createElementVNode("div", _hoisted_9, [
                            _cache[26] || (_cache[26] = _createElementVNode("label", null, "Name:", -1 /* CACHED */)),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formSectionEditor.name) = $event)),
                              class: "form-control",
                              required: "",
                              minlength: "2"
                            }, null, 512 /* NEED_PATCH */), [
                              [
                                _vModelText,
                                _ctx.formSectionEditor.name,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            _createElementVNode("small", _hoisted_10, _toDisplayString(_ctx.formSectionEditor.nameError), 1 /* TEXT */)
                          ])
                        ], 32 /* NEED_HYDRATION */)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("button", {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.formSectionEditor.close())),
                          type: "button",
                          class: "btn btn-outline-secondary"
                        }, "Cancel"),
                        _createElementVNode("button", _hoisted_12, _toDisplayString(_ctx.formSectionEditor.confimButtonLabel), 1 /* TEXT */)
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h6", null, [
                  _createElementVNode("a", {
                    class: "text-dark",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)))
                  }, [...(_cache[27] || (_cache[27] = [
                    _createElementVNode("i", {
                      class: "fa fa-angle-double-left",
                      "aria-hidden": "true"
                    }, null, -1 /* CACHED */),
                    _createTextVNode(" Back ", -1 /* CACHED */)
                  ]))])
                ]),
                _createElementVNode("h1", {
                  class: "pointer",
                  style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"},
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showFormEditor && _ctx.showFormEditor(...args)))
                }, _toDisplayString(_ctx.formName), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary mr-1",
                  style: {"padding":"0.7em 2em"},
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showFormPreview && _ctx.showFormPreview(...args)))
                }, "Preview"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-success",
                  style: {"padding":"0.7em 2em"},
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleUpdateFormDefinitionCommand && _ctx.handleUpdateFormDefinitionCommand(...args)))
                }, _toDisplayString(_ctx.saving ? 'Saving...' : 'Save form'), 1 /* TEXT */)
              ])
            ])
          ]),
          _cache[62] || (_cache[62] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0"} }, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                (_ctx.selectedField == null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _cache[29] || (_cache[29] = _createElementVNode("h6", { class: "mt-4" }, "CREATE FORM ELEMENTS", -1 /* CACHED */)),
                      _cache[30] || (_cache[30] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
                      _createElementVNode("button", {
                        class: "btn btn-outline-secondary mr-1",
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.showFormSectionCreator && _ctx.showFormSectionCreator(...args)))
                      }, "Form Section"),
                      _createElementVNode("button", {
                        class: "btn btn-outline-secondary",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.showAttributeCreator && _ctx.showAttributeCreator(...args)))
                      }, "Attribute"),
                      _cache[31] || (_cache[31] = _createElementVNode("h6", { class: "mt-4" }, "ADD FORM FIELDS", -1 /* CACHED */)),
                      _cache[32] || (_cache[32] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _withDirectives(_createElementVNode("input", {
                            type: "search",
                            placeholder: "Search...",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.searchPhrase) = $event))
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, _ctx.searchPhrase]
                          ]),
                          _cache[28] || (_cache[28] = _createElementVNode("span", { class: "input-group-append" }, [
                            _createElementVNode("span", { class: "input-group-text" }, [
                              _createElementVNode("i", {
                                class: "fa-solid fa-magnifying-glass",
                                "aria-hidden": "true"
                              })
                            ])
                          ], -1 /* CACHED */))
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attributesSections, (s) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: s.Name
                            }, [
                              (s.filteredAttributes.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    _createElementVNode("h5", _hoisted_25, [
                                      _createElementVNode("a", {
                                        class: "text-dark",
                                        onClick: ($event: any) => (s.Collapsed = !s.Collapsed)
                                      }, [
                                        _createElementVNode("i", {
                                          class: _normalizeClass(["fa mr-1", {'fa-angle-down': !s.Collapsed, 'fa-angle-right': s.Collapsed}])
                                        }, null, 2 /* CLASS */),
                                        (s.Name.length > 0)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(s.Name), 1 /* TEXT */))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_28, "Uncategorized"))
                                      ], 8 /* PROPS */, _hoisted_26)
                                    ]),
                                    (s.Collapsed === false)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                          _createElementVNode("div", _hoisted_30, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.filteredAttributes, (attr) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                class: "col-6 pb-3 pr-2",
                                                key: attr.Id
                                              }, [
                                                (attr.IsIncluded)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                      _createElementVNode("p", _hoisted_32, [
                                                        _createElementVNode("span", {
                                                          class: "name",
                                                          title: attr.AttributeName
                                                        }, _toDisplayString(_ctx.ellipsis(attr.AttributeName, 30)), 9 /* TEXT, PROPS */, _hoisted_33)
                                                      ])
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("div", {
                                                      key: 1,
                                                      class: "border rounded px-2 py-3 bg-warning",
                                                      title: attr.AttributeName,
                                                      style: {"cursor":"move"},
                                                      onDragstart: ($event: any) => (_ctx.handleDragStart($event, attr)),
                                                      onDragend: ($event: any) => (_ctx.handleDragEnd($event, attr)),
                                                      draggable: "true"
                                                    }, [
                                                      _createElementVNode("p", _hoisted_35, [
                                                        _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.ellipsis(attr.AttributeName, 30)), 1 /* TEXT */)
                                                      ])
                                                    ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_34))
                                              ]))
                                            }), 128 /* KEYED_FRAGMENT */))
                                          ])
                                        ]))
                                      : _createCommentVNode("v-if", true)
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (_ctx.selectedField != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _cache[40] || (_cache[40] = _createElementVNode("div", { class: "py-3 pl-3 bg-warning" }, [
                        _createElementVNode("h5", { class: "mb-0" }, "Editing the form field")
                      ], -1 /* CACHED */)),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("form", {
                          id: "field-editor-form",
                          onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFieldEditorFormSubmit && _ctx.handleFieldEditorFormSubmit(...args)), ["prevent"]))
                        }, [
                          _createElementVNode("div", _hoisted_39, [
                            _cache[33] || (_cache[33] = _createElementVNode("label", null, "Attribute:", -1 /* CACHED */)),
                            _createElementVNode("input", {
                              type: "text",
                              class: "form-control",
                              value: _ctx.selectedField.AttributeName,
                              readonly: ""
                            }, null, 8 /* PROPS */, _hoisted_40)
                          ]),
                          _createElementVNode("div", _hoisted_41, [
                            _cache[34] || (_cache[34] = _createElementVNode("label", null, "Label:", -1 /* CACHED */)),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control",
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedField.FieldName) = $event)),
                              required: "",
                              minlength: "2",
                              maxlength: "100"
                            }, null, 512 /* NEED_PATCH */), [
                              [
                                _vModelText,
                                _ctx.selectedField.FieldName,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _cache[35] || (_cache[35] = _createElementVNode("label", null, "Description:", -1 /* CACHED */)),
                            _withDirectives(_createElementVNode("textarea", {
                              rows: "3",
                              class: "form-control",
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedField.FieldDescription) = $event))
                            }, null, 512 /* NEED_PATCH */), [
                              [
                                _vModelText,
                                _ctx.selectedField.FieldDescription,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            _cache[36] || (_cache[36] = _createElementVNode("small", { class: "text-muted" }, "This is text that will be displayed below the form field. Like this one!", -1 /* CACHED */))
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedField.IsFieldRequired) = $event)),
                                onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleSelectedFieldIsRequiredChange && _ctx.handleSelectedFieldIsRequiredChange(...args)))
                              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                [_vModelCheckbox, _ctx.selectedField.IsFieldRequired]
                              ]),
                              _cache[37] || (_cache[37] = _createElementVNode("label", { class: "form-check-label" }, "Required field", -1 /* CACHED */))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("div", _hoisted_46, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.selectedField.IsFieldReadonly) = $event)),
                                onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.handleSelectedFieldIsReadonlyChange && _ctx.handleSelectedFieldIsReadonlyChange(...args)))
                              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                [_vModelCheckbox, _ctx.selectedField.IsFieldReadonly]
                              ]),
                              _cache[38] || (_cache[38] = _createElementVNode("label", { class: "form-check-label" }, "Readonly field", -1 /* CACHED */))
                            ])
                          ]),
                          _cache[39] || (_cache[39] = _createElementVNode("div", { class: "text-center mt-5" }, [
                            _createElementVNode("button", {
                              type: "submit",
                              form: "field-editor-form",
                              class: "btn btn-warning"
                            }, " Done field editing ")
                          ], -1 /* CACHED */))
                        ], 32 /* NEED_HYDRATION */)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _cache[41] || (_cache[41] = _createElementVNode("label", null, "Blurb:", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("textarea", {
                      rows: "1",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.blurb) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        _ctx.blurb,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _cache[42] || (_cache[42] = _createElementVNode("small", { class: "form-text text-muted" }, "Here you can provide a short blurb that will be displayed above the form fields. Up to 100 characters.", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.blurbError), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("p", _hoisted_52, [
                      _cache[43] || (_cache[43] = _createElementVNode("span", { class: "text-danger" }, "* ", -1 /* CACHED */)),
                      _createTextVNode(_toDisplayString(_ctx.alternativeLabel) + " Name (", 1 /* TEXT */),
                      _createElementVNode("a", {
                        class: "text-primary",
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.nameReadonly = !_ctx.nameReadonly))
                      }, _toDisplayString(_ctx.nameReadonly ? 'unset readonly' : 'set readonly'), 1 /* TEXT */),
                      _cache[44] || (_cache[44] = _createTextVNode(") ", -1 /* CACHED */))
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["border rounded", {'bg-color-gray3': _ctx.nameReadonly, 'bg-white': !_ctx.nameReadonly}])
                    }, [...(_cache[45] || (_cache[45] = [
                      _createElementVNode("p", { class: "text-muted mx-3 my-2" }, "Single line text...", -1 /* CACHED */)
                    ]))], 2 /* CLASS */)
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("p", _hoisted_54, [
                      _cache[48] || (_cache[48] = _createTextVNode(" Description ", -1 /* CACHED */)),
                      (_ctx.includeDescription)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_55, [
                            _cache[46] || (_cache[46] = _createTextVNode(" (", -1 /* CACHED */)),
                            _createElementVNode("a", {
                              class: "text-primary",
                              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.descriptionReadonly = !_ctx.descriptionReadonly))
                            }, _toDisplayString(_ctx.descriptionReadonly ? 'unset readonly' : 'set readonly'), 1 /* TEXT */),
                            _cache[47] || (_cache[47] = _createTextVNode(") ", -1 /* CACHED */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("label", _hoisted_57, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.includeDescription) = $event))
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelCheckbox, _ctx.includeDescription]
                        ]),
                        _cache[49] || (_cache[49] = _createElementVNode("span", { class: "slider round" }, null, -1 /* CACHED */))
                      ]),
                      (_ctx.includeDescription)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: {"margin-left":"65px"},
                            class: _normalizeClass(["border rounded", {'bg-color-gray3': _ctx.descriptionReadonly, 'bg-white': !_ctx.descriptionReadonly}])
                          }, [...(_cache[50] || (_cache[50] = [
                            _createElementVNode("p", { class: "text-muted mx-3 my-2" }, "Multi-line text..", -1 /* CACHED */)
                          ]))], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("p", _hoisted_59, [
                      _cache[53] || (_cache[53] = _createTextVNode(" Status ", -1 /* CACHED */)),
                      (_ctx.includeStatus)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_60, [
                            _cache[51] || (_cache[51] = _createTextVNode(" (", -1 /* CACHED */)),
                            _createElementVNode("a", {
                              class: "text-primary",
                              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.statusReadonly = !_ctx.statusReadonly))
                            }, _toDisplayString(_ctx.statusReadonly ? 'unset readonly' : 'set readonly'), 1 /* TEXT */),
                            _cache[52] || (_cache[52] = _createTextVNode(") ", -1 /* CACHED */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("label", _hoisted_62, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.includeStatus) = $event))
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelCheckbox, _ctx.includeStatus]
                        ]),
                        _cache[54] || (_cache[54] = _createElementVNode("span", { class: "slider round" }, null, -1 /* CACHED */))
                      ]),
                      (_ctx.includeStatus)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: {"margin-left":"65px"},
                            class: _normalizeClass(["border rounded", {'bg-color-gray3': _ctx.statusReadonly, 'bg-white': !_ctx.statusReadonly}])
                          }, [...(_cache[55] || (_cache[55] = [
                            _createElementVNode("p", { class: "text-muted mx-3 my-2" }, "Drop-down select...", -1 /* CACHED */)
                          ]))], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formSectionsView, (s) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: s.Name
                  }, [
                    (s.Name)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                          _createElementVNode("h5", null, [
                            _createElementVNode("span", {
                              class: "editable editable-warning",
                              onClick: ($event: any) => (_ctx.showFormSectionEditor(s))
                            }, _toDisplayString(s.Name), 9 /* TEXT, PROPS */, _hoisted_64)
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["drop-area", {'drop-area-hover': s.IsHovering, 'drop-area-show': _ctx.draggingAttributeId != null}]),
                      onDragover: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["prevent"])),
                      onDragenter: _withModifiers(($event: any) => (s.IsHovering = true), ["prevent"]),
                      onDragleave: ($event: any) => (s.IsHovering = false),
                      onDrop: _withModifiers(($event: any) => (_ctx.handleDropFormSection($event, s)), ["prevent"])
                    }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_65),
                    (_ctx.isFormSectionEmptyWarningVisible(s))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                          _cache[56] || (_cache[56] = _createTextVNode(" Empty sections are not supported. Please add at least 1 field or ", -1 /* CACHED */)),
                          _createElementVNode("a", {
                            class: "text-primary",
                            onClick: ($event: any) => (_ctx.handleRemoveSection(s))
                          }, "remove this section", 8 /* PROPS */, _hoisted_67),
                          _cache[57] || (_cache[57] = _createTextVNode(". If you close this window without taking one of these actions, your empty section will be deleted. ", -1 /* CACHED */))
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.Fields, (f) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: f.Id
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["d-flex form-field-container", {'selected': _ctx.selectedAttributeId === f.Id, 'hoverable': _ctx.isFormFieldHoverable(f)}])
                        }, [
                          _createElementVNode("div", {
                            class: "drag-handler bg-warning d-flex align-items-center justify-content-center",
                            title: f.FieldName,
                            style: {"cursor":"move"},
                            draggable: "true",
                            onDragstart: ($event: any) => (_ctx.handleDragStart($event, f)),
                            onDragend: ($event: any) => (_ctx.handleDragEnd($event, f))
                          }, [
                            _cache[58] || (_cache[58] = _createElementVNode("i", {
                              class: "fa fa-ellipsis-v text-white",
                              "aria-hidden": "true"
                            }, null, -1 /* CACHED */)),
                            _createElementVNode("span", _hoisted_69, _toDisplayString(f.FieldName), 1 /* TEXT */)
                          ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_68),
                          _createElementVNode("div", {
                            class: "w-100 form-field",
                            onClick: _withModifiers(($event: any) => (_ctx.selectedAttributeId = f.Id), ["stop"]),
                            title: "Edit field"
                          }, [
                            _createElementVNode("a", {
                              class: "float-right text-dark",
                              onClick: _withModifiers(($event: any) => (_ctx.handleRemoveField(f)), ["stop"]),
                              title: "Remove field"
                            }, [...(_cache[59] || (_cache[59] = [
                              _createElementVNode("i", {
                                class: "fa fa-trash",
                                "aria-hidden": "true"
                              }, null, -1 /* CACHED */)
                            ]))], 8 /* PROPS */, _hoisted_71),
                            _createElementVNode("p", _hoisted_72, [
                              (f.IsFieldRequired)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_73, "*"))
                                : _createCommentVNode("v-if", true),
                              _createElementVNode("span", _hoisted_74, _toDisplayString(f.FieldName), 1 /* TEXT */),
                              _cache[60] || (_cache[60] = _createElementVNode("i", { class: "fa fa-pencil text-muted" }, null, -1 /* CACHED */))
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["border rounded", {'bg-color-gray3': f.IsFieldReadonly, 'bg-white': !f.IsFieldReadonly}])
                            }, [...(_cache[61] || (_cache[61] = [
                              _createElementVNode("p", { class: "text-muted mx-3 my-2" }, " ", -1 /* CACHED */)
                            ]))], 2 /* CLASS */),
                            _createElementVNode("small", _hoisted_75, _toDisplayString(f.FieldDescription), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_70)
                        ], 2 /* CLASS */),
                        _createElementVNode("div", {
                          class: _normalizeClass(["drop-area", {'drop-area-hover': f.IsHovering, 'drop-area-show': _ctx.draggingAttributeId != null }]),
                          onDragover: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["prevent"])),
                          onDragenter: _withModifiers(($event: any) => (f.IsHovering = true), ["prevent"]),
                          onDragleave: ($event: any) => (f.IsHovering = false),
                          onDrop: _withModifiers(($event: any) => (_ctx.handleDropFormField($event, s, f)), ["prevent"])
                        }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_76)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}